module.exports = __webpack_public_path__ + "fonts/KaTeX_Script-Regular.073b340.woff";